import { Prop, Component, Vue } from 'vue-property-decorator';

@Component
export default class ListToolbar extends Vue {

    @Prop({ type: Boolean, required : false, default: true }) private readonly showAdd!: boolean;
    @Prop({ type: Boolean, required : false, default: true }) private readonly showEdit!: boolean;
    @Prop({ type: Boolean, required : false, default: true }) private readonly showRemove!: boolean;

    @Prop({ type: Boolean, required : false, default: false }) private readonly canAdd!: boolean;
    @Prop({ type: Boolean, required : false, default: false }) private readonly canEdit!: boolean;
    @Prop({ type: Boolean, required : false, default: false }) private readonly canRemove!: boolean;

    private add(): void {
        if (!this.showAdd || !this.canAdd) { return; }
        this.$emit('add');
    }

    private edit(): void {
        if (!this.showEdit || !this.canEdit) { return; }
        this.$emit('edit');
    }

    private remove(): void {
        if (!this.showRemove || !this.canRemove) { return; }
        this.$emit('remove');
    }

    private refresh(): void {
        this.$emit('refresh');
    }
}